module.exports = __webpack_public_path__ + "static/media/Face-with-Monocle.601059b4.webp";